import client from './client';
import type { AdminDashboard } from '@/types/admin';

export async function fetchAdminDashboard(): Promise<AdminDashboard> {
  const { data } = await client.get<AdminDashboard>('/admin/dashboard');
  return data;
}
